export const CssFontStyle = 'font-style';
export const CssFontWeight = 'font-weight';
export const CssFontStretch = 'font-stretch';
export const CssFontFamily = 'font-family';
export const JavascriptFontStyle = 'fontStyle';
export const JavascriptFontWeight = 'fontWeight';
export const JavascriptFontStretch = 'fontStretch';

export const StyleConversionArray: [string, string][] = [['italic', 'italic']];
export const WeightConversionArray: [string, string][] = [
  ['thin', '100'],
  ['extra-light', '200'],
  ['extra light', '200'],
  ['light', '300'],
  ['normal', '400'],
  ['regular', '400'],
  ['book', '400'],
  ['medium', '500'],
  ['demi-bold', '600'],
  ['demibold', '600'],
  ['semi-bold', '600'],
  ['semibold', '600'],
  ['demi', '600'],
  ['bold', '700'],
  ['heavy', '800'],
  ['black', '900'],
];
export const StretchConversionArray: [string, string][] = [
  ['compressed', 'extra-condensed'],
  ['narrow', 'condensed'],
  ['condensed', 'condensed'],
];

export const TableauFallback = 'Arial';
export const SansSerifFallback = 'sans-serif';
